import { render } from "./KeepLocal.vue?vue&type=template&id=ebe1bfd2&scoped=true"
import script from "./KeepLocal.vue?vue&type=script&lang=js"
export * from "./KeepLocal.vue?vue&type=script&lang=js"

import "./KeepLocal.vue?vue&type=style&index=0&id=ebe1bfd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ebe1bfd2"

export default script